import { render } from "./NewAge.vue?vue&type=template&id=2524560a&scoped=true"
import script from "./NewAge.vue?vue&type=script&lang=js"
export * from "./NewAge.vue?vue&type=script&lang=js"

import "./NewAge.vue?vue&type=style&index=0&id=2524560a&lang=scss&scoped=true"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2524560a"]])

export default __exports__